import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

// enforced in backend - to modify, make sure to increase VARCHAR limit
// on database column and on the AnalyticsQuery/AnalyticsDashboard model classes
export const FRONTEND_MAX_DESCRIPTION_LENGTH = 1500;

export interface AnalyticsDescriptionEditorProps {
  description: string;
  setDescription: (newValue: string) => void;
}

export default function AnalyticsDescriptionEditor(props: AnalyticsDescriptionEditorProps): JSX.Element {
  return (
    <textarea
      maxLength={FRONTEND_MAX_DESCRIPTION_LENGTH}
      onChange={(e) => {
        props.setDescription(e.target.value);
      }}
      placeholder="Optional"
      rows={3}
      value={props.description}
      {...getTestProps({component: 'AnalyticsDescriptionEditor', element: 'descriptionTextArea'})}
    />
  );
}
